import React, { useState } from "react";
import OfferForm from "../Form/OfferForm";
import { formatAxiosErrorMessage, postOrThrow } from "../../../../_api";
import { useHistory } from "react-router-dom";
import { Alert, Container, Stack, Text, Title } from "@mantine/core";

const AddOffer: React.FC = () => {
  const history = useHistory();
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Nowa oferta</Title>
        {submitError ? (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano oferty"
            withCloseButton
            onClose={() => setSubmitError(null)}
            mb="md"
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        ) : null}
        <OfferForm
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await postOrThrow("offers", values);
              if (res) {
                history.push("/offers");
              }
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
      </Stack>
    </Container>
  );
};

export default AddOffer;
